import { atom } from 'jotai';

export const isBuyingFanTokenOfferingAtom = atom(false);
